export const DEFAULT_COMPONENTS = {
  defaultPaymentType: "",
  paymentTypes: [""],
  startOnLoad: false,
  callbacks: {},
};
